
export class StorePortfolioPropertyRequest{
    public userId!:string;
    public businessId!:string;
    public portfolioId?:number;
    public propertyId!:number;
    public reason?:string;
}